<template>
    <el-scrollbar class="data-evaluation" style="height: 100%;">
        <div class="class-change">
            <div class="label-text">班级：</div>

            <el-radio-group v-model="classRadio">
                <el-radio :label="'电商1班'">电商1班</el-radio>
                <el-radio :label="'电商2班'">电商2班</el-radio>
                <el-radio :label="'电商3班'">电商3班</el-radio>
            </el-radio-group>
        </div>

        <div class="attitude-assessment">
            <div class="attitude-assessment_label">态度考核</div>

            <div class="filter-box">
                <div class="filter-label">章节:</div>
                <el-cascader
                    v-model="course1"
                    :options="courseList"
                    @change="handleChange"
                    size="small"
                    :show-all-levels="false"
                ></el-cascader>
            </div>

            <div class="attitude-assessment_table">
                <el-table
                    :data="getAttitudeTableData"
                    size="medium"
                    :header-cell-style="{ fontWeight: 'normal', color: '#333', background: '#FDEEED' }"
                    class="table-content"
                    :cell-style="{ fontSize: '12px', color: '#333' }"
                >
                    <el-table-column :align="'center'" prop="studentName" label="学员"> </el-table-column>
                    <el-table-column :align="'center'" prop="attendance" label="主动性"> </el-table-column>
                    <el-table-column :align="'center'" prop="participation" label="沟通能力"> </el-table-column>
                    <el-table-column :align="'center'" prop="homeworkCompletion" label="适应性"> </el-table-column>
                    <el-table-column :align="'center'" prop="cooperation" label="专业度"> </el-table-column>
                    <el-table-column :align="'center'" prop="attitude" label="问题解决能力"> </el-table-column>
                    <el-table-column :align="'center'" prop="classroomPerformance" label="时间管理"> </el-table-column>
                    <el-table-column :align="'center'" prop="problemSolving" label="情绪管理"> </el-table-column>
                    <el-table-column :align="'center'" prop="communication" label="任务导向"> </el-table-column>
                    <el-table-column :align="'center'" width="150" prop="selfDrive" label="自我反思与改进"> </el-table-column>
                </el-table>
            </div>

            <div class="filter-box">
                <div class="filter-label">章节:</div>
                <el-cascader
                    v-model="course2"
                    :options="courseList"
                    @change="handleChange"
                    size="small"
                    :show-all-levels="false"
                ></el-cascader>

                <div class="filter-label" style="margin-left: 20px;">学生:</div>
                <el-select v-model="studentValue" placeholder="请选择学生" size="small">
                    <el-option v-for="item in studentOption" :key="item" :label="item" :value="item"> </el-option>
                </el-select>
            </div>
        </div>

        <div class="exam-assessment">
            <div class="type-change">
                <div :class="['type-item', 'left', { 'is-current': examType === 1 }]" @click="handleChangeExamType(1)">技能成绩</div>
                <div :class="['type-item', 'right', { 'is-current': examType === 2 }]" @click="handleChangeExamType(2)">知识成绩</div>
            </div>

            <div class="filter-box">
                <div class="filter-label">名称:</div>
                <el-input
                    v-model="examFilter.name"
                    placeholder="请输入"
                    style="width: 215px"
                    size="small"
                    @input="pageParams.page = 1"
                ></el-input>

                <div class="filter-label" style="margin-left: 20px;">状态:</div>
                <el-select v-model="examFilter.status" placeholder="请选择" size="small" @change="pageParams.page = 1">
                    <el-option label="全部" :value="'全部'"> </el-option>
                    <el-option label="进行中" :value="'进行中'"> </el-option>
                    <el-option label="已结束" :value="'已结束'"> </el-option>
                </el-select>
            </div>

            <div class="exam-assessment_table">
                <el-table
                    :data="getExamTableData.slice((pageParams.page - 1) * pageParams.size, pageParams.page * pageParams.size)"
                    size="medium"
                    :header-cell-style="{ fontWeight: 'normal', color: '#333', background: '#FDEEED' }"
                    class="table-content"
                    :cell-style="{ fontSize: '12px', color: '#333' }"
                >
                    <el-table-column :align="'center'" prop="homeworkName" label="考试名称"> </el-table-column>
                    <el-table-column :align="'center'" label="考试状态">
                        <template slot-scope="scope">
                            <div class="exam-status">
                                <i :class="{ 'is-over': scope.row.homeworkStatus === '已结束' }" v-if="examType === 2"></i>
                                <span>{{ scope.row.homeworkStatus }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :align="'center'" prop="submissionStatus" label="提交状态"> </el-table-column>
                    <el-table-column :align="'center'" prop="literacyScore" label="素养成绩" v-if="examType === 1"> </el-table-column>

                    <el-table-column :align="'center'" prop="individualScore" label="个人成绩"> </el-table-column>
                    <el-table-column :align="'center'" prop="classHighestScore" label="班级最高分"> </el-table-column>
                    <el-table-column :align="'center'" prop="classLowestScore" label="最低分"> </el-table-column>
                    <el-table-column :align="'center'" prop="averageScore" label="平均分"> </el-table-column>
                </el-table>
            </div>

            <div class="pagination">
                <el-pagination
                    :current-page="pageParams.page"
                    :page-size="pageParams.size"
                    @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next, jumper"
                    :total="getExamTableData.length"
                >
                </el-pagination>
            </div>
        </div>
    </el-scrollbar>
</template>

<script>
import { getTeaSchoolCourse } from "@/utils/apis.js";
import Data from "./Data.js";

export default {
    data() {
        return {
            courseList: [],
            course1: [],
            course2: [],
            chapterList: [],
            classRadio: "电商1班",
            studentOption: Data.students,
            studentValue: Data.students[0],
            attitudeIndex: 0,
            examType: 1,
            examFilter: {
                name: "",
                status: "全部",
            },
            pageParams: {
                page: 1,
                size: 5,
            },
            dataMap: null,
        };
    },
    created() {
        this.getTeacherCourseList();
    },
    mounted() {},
    computed: {
        getAttitudeTableData() {
            if (!this.dataMap) return [];

            const classMap = this.dataMap.get(this.classRadio);
            return classMap.attitudeAssessment.get(this.course1.join("-"));
        },
        getExamTableData() {
            if (!this.dataMap) return [];

            let tableData = [];
            const classMap = this.dataMap.get(this.classRadio);
            if (this.examType === 1) {
                tableData = classMap.skillAssesssment.get(`${this.studentValue}_${this.course2.join("-")}`);
            } else if (this.examType === 2) {
                tableData = classMap.knowAssessment.get(`${this.studentValue}_${this.course2.join("-")}`);
            }

            return tableData.filter((item) => {
                let flag = item.homeworkName.includes(this.examFilter.name);

                if (this.examFilter.status !== "全部") {
                    flag = flag & (item.homeworkStatus === this.examFilter.status);
                }

                return flag;
            });
        },
    },
    methods: {
        handleCurrentChange(val) {
            this.pageParams.page = val;
        },

        getTeacherCourseList() {
            getTeaSchoolCourse().then((res) => {
                if (res.code === 200) {
                    res.data.forEach((item) => {
                        const optionItem = {
                            value: item.course_name,
                            label: item.course_name,
                        };

                        if (item.data && item.data.length > 0) {
                            optionItem.children = this.formatterChild(item.data);
                        }
                        this.courseList.push(optionItem);
                    });

                    this.course1 = this.setInitCourse(this.courseList[0], []);
                    this.course2 = this.setInitCourse(this.courseList[0], []);
                    this.setChapterList(this.courseList, []);

                    const assessmentData = new Data(["电商1班", "电商2班", "电商3班"], this.chapterList)
                    this.dataMap = assessmentData.classMap;
                }
            });
        },

        formatterChild(options) {
            const result = [];
            options.forEach((item) => {
                const option = {
                    value: item.name,
                    label: item.name,
                };

                if (item.child && item.child.length > 0) {
                    option.children = this.formatterChild(item.child);
                }

                result.push(option);
            });

            return result;
        },

        setInitCourse(option, result) {
            result.push(option.value);
            if (option.children && option.children.length > 0) {
                this.setInitCourse(option.children[0], result);
            }

            return JSON.parse(JSON.stringify(result));
        },

        setChapterList(options, result) {
            options.forEach((item) => {
                result.push(item.value);

                if (item.children && item.children.length > 0) {
                    this.setChapterList(item.children, result);
                } else {
                    this.chapterList.push(result.join("-"));
                }

                result.pop();
            });
        },

        handleChange() {
            this.pageParams.page = 1;
        },

        handleChangeExamType(type) {
            this.pageParams.page = 1;
            this.examType = type;
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
}

.data-evaluation {
    ::v-deep .el-cascader .el-input .el-input__inner:focus,
    ::v-deep .el-cascader .el-input.is-focus .el-input__inner,
    ::v-deep .el-select .el-input.is-focus .el-input__inner,
    ::v-deep .el-select .el-input__inner:focus,
    ::v-deep .el-input__inner:focus {
        border-color: #0966ee;
    }

    ::v-deep .el-radio__input.is-checked {
        border-radius: 50%;
        border: 1px solid #f23b2f;
        width: 14px;
        height: 14px;

        .el-radio__inner {
            width: 8px;
            height: 8px;
            margin: 3px;

            &::after {
                display: none;
            }
        }

        & + .el-radio__label {
            color: #333333;
        }
    }

    .class-change {
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 0 24px;
        .label-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
        }
    }

    .filter-box {
        margin-top: 28px;
        display: flex;
        align-items: center;
        gap: 20px;

        .filter-label {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 16px;
        }
    }

    .attitude-assessment {
        padding: 45px 24px 20px;
        border-bottom: 1px solid #eeeeee;

        &_label {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
        }

        &_table {
            padding: 20px 0px;

            .el-table {
                width: 65%;
                border: 1px solid #ebeef5;
                border-bottom: none;
                border-radius: 4px;

                &::before {
                    display: none;
                }

                ::v-deep .cell {
                    color: #3e3e3e;
                    font-size: 14px;
                }

                ::v-deep td {
                    background-color: #fbf9f9;
                }
            }
        }
    }

    .exam-assessment {
        padding: 20px 24px;

        .type-change {
            display: flex;

            .type-item {
                width: 96px;
                height: 38px;
                border: 1px solid #d3d3d3;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                cursor: pointer;

                &.left {
                    border-radius: 4px 0px 0px 4px;
                    border-right: none;
                }

                &.right {
                    border-radius: 0px 4px 4px 0px;
                    border-left: none;
                }

                &.is-current {
                    border: none;
                    background-color: #f23b2f;
                    color: #ffffff;
                }
            }
        }

        &_table {
            padding: 20px 0px;

            .el-table {
                width: 65%;
                border: 1px solid #ebeef5;
                border-bottom: none;
                border-radius: 4px;

                &::before {
                    display: none;
                }

                ::v-deep .cell {
                    color: #3e3e3e;
                    font-size: 14px;
                }

                ::v-deep td {
                    background-color: #fbf9f9;
                }

                .exam-status {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    justify-content: center;

                    i {
                        display: inline-block;
                        width: 6px;
                        height: 6px;
                        border-radius: 50%;
                        background-color: #2fc359;

                        &.is-over {
                            background-color: #ff2323;
                        }
                    }
                }
            }
        }

        .pagination {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 50px;

            ::v-deep .el-pagination__editor.el-input .el-input__inner {
                background-color: #f4f5f9;
            }

            ::v-deep .el-input__inner:focus {
                border-color: #dddddd;
            }
        }
    }
}
</style>
